/**
 * 应用中心静态路由数据
 * */

export default {
  path: '/appCenter',
  name: 'appCenter',
  component: () => import('@/views/index/components/appCenter/index.vue'),
  meta: {
    unrequireLogin: true
  }
}
